import { clientFetch } from "./clientFetch";

export type RoleType = 'CUSTOMER' | 'EMPLOYEE' | 'SUPPLIER';

export interface Contact {
  id: number;
  uid: string;
  name: string;
  document_type: string;
  document_number: string;
  company_id: number;
  address: string;
  email: string;
  phone: string;
  requires_electronic_invoice: boolean;
  roles?: { role_type: RoleType }[];
  role?: RoleType;
}

export const ContactService = {
  createContact: (contact: Partial<Contact>, company: string, key: string) =>
    clientFetch('/user/contact/create-contact', 'POST', key, { body: { company, contact } }),

  updateContact: (contactId: string, contact: Partial<Contact>, company: string, key: string) =>
    clientFetch('/user/contact/update-contact', 'POST', key, { body: { company, uidContact: contactId, contact } }),

  getContactById: (uidContact: string, company: string, key: string) =>
    clientFetch('/user/contact/get-contact', 'POST', key, { body: { company, uidContact } }),

  getBulkContacts: (role: RoleType, company: string, key: string) =>
    clientFetch('/user/contact/get-bulk-contacts', 'POST', key, { body: { company, role } }),

  searchBulkContacts: (search: string, role: RoleType, company: string, key: string) =>
    clientFetch('/user/contact/search-bulk-contacts', 'POST', key, { body: { company, search, role } }),
};
